import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';

export const CONTENT_REVIEWER_AGENT_CONFIG = 'platform_editor_ai_content_reviewer_agent_config';

const AGENT_ID_PARAMETER = 'value';

/** An absent or invalid override leaves the existing OOTB resolution path in place. */
export function getConfiguredContentReviewerAgentIds(): string[] | undefined {
	try {
		const value = expVal(CONTENT_REVIEWER_AGENT_CONFIG, AGENT_ID_PARAMETER, '');
		const normalizedAgentIds = [
			...new Set(
				value
					.split(',')
					.map((id) => id.trim())
					.filter(Boolean),
			),
		];

		return normalizedAgentIds.length ? normalizedAgentIds : undefined;
	} catch {
		return undefined;
	}
}

/** The first configured agent supplies the identity shown by single-agent loading surfaces. */
export function getConfiguredContentReviewerAgentId(): string | undefined {
	return getConfiguredContentReviewerAgentIds()?.[0];
}
